<style>
	.p-t-30 {
		padding-top: 30px;
	}

	.drag-handler, .category-details, .nest-buttons, .nest-collapser-mini {
		display: inline-block;
	}

	.category-details {
		padding-left: 10px;
	}

	.nest-buttons {
		text-align: right;
		float: right;
	}

	.nest-collapser-mini {
		color: #424242;
		padding-left: 10px;
	}

	.pad1030 {
		padding-left: 10px !important;
		padding-right: 10px !important;
	}
</style>
<template>
	<section class="section-container" v-if="!is_supplier">
		<div class="content-wrapper">
			<div class="content-heading" v-if="tender.id">
				{{$t('productcat.edit-title')}}
			</div>
			<div class="content-heading" v-else>
				<div class="container-fluid">
					<div class="row">
						<div class="col-md-6">
							<div>{{$t('productcat.title')}}</div>
						</div>
						<div class="col-md-6 text-right">
							<router-link :to="{ name: 'admin_product_cat_add'}" class="add-new btn btn-warning">
								{{$t('productcat.add')}}
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<!-- Filtration -->
			<div class="row filter-row">
				<div class="col-xl-12">
					<div id="accordion">
						<div class="card mb-1">
							<div class="card-header" id="headingOne">
								<h4 class="mb-0">
									{{$t('productcat.searchform')}}
									<a class="text-inherit" data-toggle="collapse" data-target="#collapseOne"
									   aria-expanded="true" aria-controls="collapseOne" href="">
										<i class="icon-arrow-down"></i>
									</a>

								</h4>
							</div>
							<div class="collapse show" id="collapseOne" aria-labelledby="headingOne"
								 data-parent="#accordion">
								<div class="card-body border-top">
									<form>
										<div class="form-row align-items-center">
											<div class="col-md-5">
												<label class="sr-only"
													   for="tarnija">{{$t('productcat.search-placeholder')
													}}</label>
												<input class="form-control mb-12 tree-search" id="tarnija" type="text"
													   :placeholder="$t('productcat.search-placeholder')"
													   v-model="searchBarInput"
													   v-on:input="filterBySearchBar(searchBarInput)"/>
											</div>
										</div>
									</form>
									<!-- Group selection -->
									<div class="row p-t-30">
										<div class="col-2" v-for="(group, idx) in groups" :key="'group-'+idx">
											<div class="checkbox c-checkbox">
												<label class="mb-0">
													<input
															type="checkbox"
															class="select-box"
															:checked="selectedDivision == group.id"
															@click="switchGroup(group.id)"
													>
													<span class="fa fa-check"> </span>{{group.name}}
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>

				</div>

			</div>
			<!--  Content -->
			<div class="row">
				<div class="col-xl-12">
					<div class="container-fluid">

						<div class="row">
							<div class="col-lg-5">

							</div>
							<div class="col-lg-5">

							</div>
						</div>
						<div class="row">
							<div class="col-lg-5 tree-wrapper">
								<div class="tree-card-header">
									<div class="row">
										<div class="col-md-6">
											<h4 class="title">{{$t('productcat.structure')}}</h4>
										</div>
										<div class="col-md-6 text-right pull-right">
											<div class="js-nestable-action">
												<a class="btn btn-secondary btn-sm mr-1"
												   @click="collapseExpand(false)">{{$t('productcat.expand')}}</a>
												<a class="btn btn-secondary btn-sm"
												   @click="collapseExpand(true)"
												>{{$t('productcat.collapse')}}</a>
											</div>
										</div>
									</div>
								</div>

								<div class="nestable-container">
									<VueNestable
											v-if="listItems.length > 0"
											v-model="listItems"
											:max-depth="5"
											:hooks="{
												'beforeMove': beforeMove,
												'moveItem': moveItem
											}"
											@change="onTreeChange"
											@input="onTreeInput"
											children-prop="nested"
											class-prop="class"
											key-prop="key"
											cross-list
											group="cross">
										<template slot-scope="{ item }">
											<div
													class="category-row"
													:class="
														item.type == 'productclass' ? 'red' : ''
														|| item.type == 'inactive' ? 'grey-out' : ''
														|| item.collapsed ? 'collapsed-parent-'+item.key : ''"
													data-collapse="open">

												<!-- Collapse handler -->
												<div class="drag-handler">
													<a href="#" class="nest-collapser-mini nest-collapser"
													   @click="collapseNest(item)"
													   v-if="item.nested.length>0 && !item.collapsed">
														<i class="icon-arrow-down collapser-icon"></i>
													</a>
													<a href="#" class="nest-collapser-mini nest-collapser"
													   @click="collapseNest(item)"
													   v-if="item.nested.length>0 && item.collapsed">
														<i class="icon-arrow-right collapser-icon"></i>
													</a>
												</div>

												<!-- Main text -->
												<VueNestableHandle :item="item">
													<div
															class="category-details"
															:class="item.type == 'inactive' ? 'grey-out' : ''">
														{{item.text}}
														<span
																class="code"
																v-if="item.code > 0">
														({{item.code}})
													</span>
														<span
																class="productClass tree-productClass"
																v-if="item.productClass.key > 0">

														({{item.productClass.text}})
													</span>
													</div>
												</VueNestableHandle>

												<!-- End of main text -->
												<!-- Button area -->
												<div class="nest-buttons text-right pull-right">
													<div class="btn-group" v-if="item.type != 'row'">

														<button class="btn btn-secondary btn-pill btn-none"
																type="button" data-toggle="dropdown">
															<i class="icon-options-vertical"></i>
														</button>

														<!-- Dropdown menu -->
														<div class="dropdown-menu" role="menu">
															<a class="dropdown-item" href="#">
																<router-link
																		:to="'/admin/product/categories/'+item.key+'/edit'"
																		class="router-no-link"
																>
																	<i class="icon-note"></i> {{$t('productcat.edit')}}
																</router-link>
															</a>
															<!-- Back button -->
															<a class="dropdown-item" href="#"
															   v-if="item.nested.length == 0"
															   @click="revertNestCategory(item)">
																<i class="icon-reload"></i> {{$t('productcat.revert')}}
															</a>

															<!-- Inactive button -->
															<a v-if="item.type =='category' && item.nested.length == 0"
															   class="dropdown-item"
															   href="#"
															   @click="setInactive(item);">
																<i class="icon-ban"></i> {{$t('productcat.inactive')}}
															</a>

															<!-- Active button -->
															<a v-if="item.type =='inactive'"
															   class="dropdown-item"
															   href="#"
															   @click="setItemState(item,'active');">
																<i class="icon-check"></i> {{$t('productcat.active')}}
															</a>

															<div class="dropdown-divider"
																 v-if="item.nested.length == 0">
															</div>

															<!-- Trash button -->
															<a class="dropdown-item" href="#"
															   v-if="item.nested.length == 0"
															   @click="trashRow(item)">
																<i class="icon-trash"> </i> {{$t('productcat.trash')}}
															</a>
														</div>
														<!-- End of dropdown menu -->
													</div>
												</div>
											</div>
										</template>
									</VueNestable>
									<!--<NestableItem v-model="nestableItems" :code="true"></NestableItem>-->
								</div>
							</div>
							<div class="col-lg-3">
								<div class="dd" id="nestable2">
									<h4 class="title">{{$t('productcat.newcategories')}}</h4>
									<div class="nestable-container">

										<div class="nestable" v-for="(nestCategory, idx) in newCategories"
											 :key="'newcat-'+idx"
										>
											<div class="nestable-item">
												<div class="nestable-item-content">
													<div class="category-row">
														<div class="drag-handler">
															<a href="#" @click="moveToTree(nestCategory)">
																<i class="icon-arrow-left"></i>
															</a>
														</div>
														<div class="category-details">
															<span>{{nestCategory.text}}</span>
														</div>
														<div class="nest-buttons text-right pull-right">
															<div class="btn-group" v-if="nestCategory.type != 'row'">
																<button class="btn btn-secondary btn-pill btn-none"
																		type="button" data-toggle="dropdown">
																	<i class="icon-options-vertical"></i>
																</button>
																<div class="dropdown-menu" role="menu">
																	<a class="dropdown-item" href="#">
																		<router-link
																				:to="'/admin/product/categories/'+nestCategory.key+'/edit'"
																				class="router-no-link"
																		>
																			<i class="icon-note"></i>
																			{{$t('productcat.edit')}}
																		</router-link>
																	</a>
																	<a v-if="nestCategory.card =='category'"
																	   class="dropdown-item" href="#"
																	   @click="setInactive(nestCategory);">
																		<i class="icon-ban"></i>
																		{{$t('productcat.inactive')}}</a>

																	<div class="dropdown-divider"></div>
																	<a
																			class="dropdown-item" href="#"
																			@click="trashRow(item)"> <i
																			class="icon-trash"
																	>
																	</i> {{$t('productcat.trash')}}</a>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<!--<NestableItem v-model="newCategories" :code="false" ></NestableItem>-->
									</div>

								</div>
							</div>

							<div class="col-lg-3">
								<div class="dd" id="nestable4">
									<h4 class="title">{{$t('productcat.unactivecategories')}}</h4>
									<div class="nestable-container">
										<div class="nestable" v-for="(unactiveCategory, idx) in unactiveCategories"
											 :key="'inactive'+idx"
										>
											<div class="nestable-item">
												<div class="nestable-item-content">
													<div class="category-row">

														<div class="category-details">
															<span>{{unactiveCategory.text}}</span>

														</div>
														<div class="nest-buttons text-right pull-right">
															<div class="btn-group"
																 v-if="unactiveCategory.type != 'row'">
																<button class="btn btn-secondary btn-pill btn-none"
																		type="button" data-toggle="dropdown">
																	<i class="icon-options-vertical"></i>
																</button>
																<div class="dropdown-menu" role="menu">
																	<a class="dropdown-item" href="#">
																		<router-link
																				:to="'/admin/product/categories/'+unactiveCategory.key+'/edit'"
																				class="router-no-link"
																		>
																			<i class="icon-note"></i>
																			{{$t('productcat.edit')}}
																		</router-link>
																	</a>
																	<a @click="setActive(unactiveCategory);"
																	   class="dropdown-item" href="#"> <i
																			class="icon-check"></i>
																		{{$t('productcat.active')}}</a>
																	<div class="dropdown-divider"></div>
																	<a class="dropdown-item" href="#"> <i
																			class="icon-trash"></i>
																		{{$t('productcat.trash')}}</a>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<modal v-if="showModal">
			<h4 class="modal-title" slot="header-text">{{ $t('modal.header.text') }}</h4>
			<div class="modal-body" slot="modal-body">
				<p class="text-bold">{{ $t('modal.section1.header') }}</p>
				<p>{{ modal_data_1 }}</p>
				<p class="text-bold">{{ $t('modal.section2.header') }}</p>
				<p>{{ modal_data_2}}</p>
			</div>
			<div slot="modal_buttons">
				<button class="btn btn-secondary" type="button" @click="close_modal()">{{ $t('modal.close') }}</button>
			</div>
		</modal>

	</section>
</template>

<script>
	import api from '@/api'
	import message from '@/message'
	import {Datetime} from 'vue-datetime'
	import Pagination from '@/components/Pagination.vue'
	import Search from '@/components/Search.vue'
	import {parseApiError} from '@/utils'
	import Modal from '@/components/Modal.vue'
	import Multiselect from 'vue-multiselect'
	import NestableItem from '@/components/Nestable/NestableItem';

	const getData = (id, route, next) => {
		const search = route.query.search
		const ordering = route.query.ordering || 'pk'
		const page = parseInt(route.query.page) || 1
		const start = route.query.start
		const finish = route.query.finish
		const warehouse = route.query.warehouse || null
		const additional = route.query.additional || ''
		const tenderId = route.query.tender_id || null
		const group = route.query.group || null

		if (!id && tenderId) {
			id = tenderId
		}
		let selectedDivision = localStorage.selectedDivision;

		if (id) {

			Promise.all([
				api.get(`/tenders/${id}/`),
				api.get(`/details/`, {
					params: {
						page_size: 500,
						tender: id,
						search: search,
						ordering: ordering,
						page: 1
					}
				}),
				api.get('/warehouses/?is_active=true&page_size=1000'),
				api.get(`/profile/`)
			])
				.then(([tender, chosen, warehouses, profile]) => {
					let rows = {}
					api.get(`/details/`, {
						params: {
							status: 'PREPARED',
							warehouse: tender.data.warehouse,
							page_size: 50,
							search: search,
							ordering: ordering,
							page: page
						}
					})
						.then(resp => {
							rows = resp.data
							rows.results.forEach(r => {
								if (r.qty === null) {
									r.qty = r.replenishment_qty + r.replacement_qty > 0 ? r.replenishment_qty + r.replacement_qty : 0
								}
							})

							let rowsChosen = chosen.data.results
							rowsChosen.forEach(r => {
								if (r.qty === null) {
									r.qty = r.replenishment_qty + r.replacement_qty > 0 ? r.replenishment_qty + r.replacement_qty : 0
								}
							})

							let userWarehouses = []
							warehouses.data.results.forEach(w => {
								if (w.group === tender.data.group) {
									userWarehouses.push(w)
								}
							})

							tender.data.warehouse = {
								'id': tender.data.warehouse,
								'name': tender.data.warehouse_name
							}

							tender.data.group = {
								'id': tender.data.group,
								'name': tender.data.group_name
							}

							next({
								tender: tender.data,
								user_warehouse: tender.data.warehouse,
								details: rows.results,
								search: search,
								ordering: ordering,
								chosen: rowsChosen,
								page: page,
								pages: rows ? rows.pages : 1,
								warehouses: userWarehouses,
								groups: profile.data.results ? profile.data.results[0].warehouse_groups_options : []
							})
						})
				})
		} else {
			Promise.all([
				api.get('/groups/?page_size=100'),
				api.get('/categories/tree/' + selectedDivision + '/', {}),
			])
				.then(([groupsList, tree]) => {
					let list = [];
					let categories = [];
					let inactives = [];
					let groups = [];

					groupsList.data.results.forEach(g => {
						groups.push(g);
					});

					//list
					if (tree.data.tree.list.length > 0) {
						tree.data.tree.list.forEach(r => {

							let childRows = [];
							// First dimension
							r.nested.forEach(child => {
								let secondChildList = [];

								// Second dimension
								if (child.nested.length > 0) {
									child.nested.forEach(secondChild => {
										// Third last dimension
										let thirdChildList = [];
										secondChild.nested.forEach(thirdChild => {
											let fourthChildList = [];
											if (thirdChild.nested.length > 0) {
												thirdChild.nested.forEach(fourthChild => {
													let tempFourthChild = {
														key: fourthChild.key,
														class: 'purple-text-color',
														text: fourthChild.text,
														productClass: fourthChild.class,
														type: 'category',
														collapsed: false,
														nested: fourthChild.nested,
														visible: true,
														card: 'tree',
													};
													fourthChildList.push(tempFourthChild);
												})
											}

											let tempThirdChild = {
												key: thirdChild.key,
												class: 'purple-text-color',
												text: thirdChild.text,
												productClass: thirdChild.class,
												type: 'category',
												collapsed: false,
												nested: fourthChildList,
												visible: true,
												card: 'tree',
											};
											thirdChildList.push(tempThirdChild);

										});

										let secondTempChild = {
											key: secondChild.key,
											class: 'purple-text-color',
											text: secondChild.text,
											productClass: secondChild.class,
											type: 'category',
											collapsed: false,
											nested: thirdChildList,
											visible: true,
											card: 'tree',
										};
										secondChildList.push(secondTempChild);
									});
								}

								let childRow = {
									key: child.key,
									class: 'purple-text-color',
									text: child.text,
									productClass: child.class,
									type: 'category',
									collapsed: false,
									nested: secondChildList,
									visible: true,
									card: 'tree',
								};
								childRows.push(childRow);
							});
							let rowData = {
								key: r.key,
								class: 'purple-text-color',
								text: r.text,
								productClass: r.class,
								type: 'category',
								collapsed: false,
								nested: childRows,
								visible: true,
								card: 'tree',
							};
							list.push(rowData);
						})
					}
					//categories,classes,inactives
					if (tree.data.tree.categories.length > 0) {
						tree.data.tree.categories.forEach(r => {
							let rowData = {
								key: r.key,
								class: 'purple-text-color',
								text: r.text,
								type: 'category',
								collapsed: false,
								visible: true,
								card: 'category',
							};
							categories.push(rowData);
						})
					}

					if (tree.data.tree.inactives.length > 0) {
						tree.data.tree.inactives.forEach(r => {
							let rowData = {
								key: r.key,
								class: 'purple-text-color',
								text: r.text,
								type: 'inactive',
								collapsed: false,
								visible: true,
								card: 'inactive',
							};
							inactives.push(rowData);
						})
					}

					next({
						listItems: list,
						newCategories: categories,
						unactiveCategories: inactives,
						groups: groups
					})
				})
		}
	}

	export default {
		components: {
			datetime: Datetime,
			pagination: Pagination,
			search: Search,
			modal: Modal,
			Multiselect,
			NestableItem
		},
		data() {
			return {
				tender: {
					id: null,
					start: null,
					finish: null,
					additional_info: '',
					warehouse: null
				},
				listItems: [],
				newCategories: [],
				productClasses: [],
				searchBarInput: '',
				unactiveCategories: [],
				details: [],
				warehouses: [],
				groups: [],
				chosen: [],
				search: null,
				user_warehouse: null,
				ordering: null,
				count: null,
				errors: {},
				page: null,
				pages: null,
				showModal: false,
				modal_data_1: null,
				modal_data_2: null,
				warehouse_changed: false,
				selectedDivision: 1,
			}
		},
		watch: {
			selectedDivision(newVal) {
				localStorage.selectedDivision = newVal;
			}
		},
		mounted() {
			this.$parent.menu = 'productcat';
			this.$parent.submenu = '';
			this.$i18n.locale = this.$store.getters.language;

			if (localStorage.selectedDivision > 0) {
				this.selectedDivision = localStorage.selectedDivision;
			}
		},
		computed: {
			nestableItems: {
				get() {
					return this.$store.state.nestableItems;
				},
				set(value) {
					this.$store.dispatch('updateElements', value);
				}
			},
			is_supplier() {
				return this.$store.getters.user_group === 'Supplier'
			},
			totalReplacementQtyChosen() {
				let total = 0
				for (let i = 0; i < this.chosen.length; i++) {
					total += this.chosen[i].replacement_qty > 0 ? this.chosen[i].replacement_qty : 0
				}
				return total
			},
			totalReplenishmentQtyChosen() {
				let total = 0
				for (let i = 0; i < this.chosen.length; i++) {
					total += this.chosen[i].replenishment_qty > 0 ? this.chosen[i].replenishment_qty : 0
				}
				return total
			},
			totalQtyChosen() {
				let total = 0
				for (let i = 0; i < this.chosen.length; i++) {
					total += this.chosen[i].replacement_qty + this.chosen[i].replenishment_qty > 0
						? this.chosen[i].replacement_qty + this.chosen[i].replenishment_qty : 0
				}
				return total
			},
			totalChosen() {
				let total = 0
				this.chosen.forEach(c => {
					if (c.qty && c.qty > 0) {
						total += Number(c.qty)
					}
				})
				return total
			}
		},
		methods: {
			collapseExpand(value) {
				for (var i = 0; i < this.listItems.length; i++) {

					if (this.listItems[i].nested.length > 0) {
						this.listItems[i].collapsed = value;
						this.toggleAccordion(
							this.listItems[i], this.listItems[i].collapsed
						);
					}

					// Second dimension
					if (this.listItems[i].nested.length > 0) {
						for (var j = 0; j < this.listItems[i].nested.length; j++) {
							if (this.listItems[i].nested[j].nested.length > 0) {
								this.listItems[i].nested[j].collapsed = (!this.listItems[i].nested[j].collapsed) ? true : false;
								this.toggleAccordion(
									this.listItems[i].nested[j],
									this.listItems[i].nested[j].collapsed
								);
							}

							// Third dimension
							for (var k = 0; k < this.listItems[i].nested[j].nested.length; k++) {
								if (this.listItems[i].nested[j].nested[k].nested.length > 0) {
									this.listItems[i].nested[j].nested[k].collapsed = (!this.listItems[i].nested[j].nested[k].collapsed) ? true : false;
									this.toggleAccordion(
										this.listItems[i].nested[j].nested[k],
										this.listItems[i].nested[j].nested[k].collapsed
									);
								}
							}
						}
					}
				}
			},
			collapseNest(item) {
				for (var i = 0; i < this.listItems.length; i++) {
					if (this.listItems[i].key == item.key) {
						this.listItems[i].collapsed = (!this.listItems[i].collapsed) ? true : false;
						this.toggleAccordion(item, this.listItems[i].collapsed);
					}

					// Second dimension
					if (this.listItems[i].nested.length > 0) {
						for (var j = 0; j < this.listItems[i].nested.length; j++) {
							if (this.listItems[i].nested[j].key == item.key) {
								this.listItems[i].nested[j].collapsed = (!this.listItems[i].nested[j].collapsed) ?
									true : false;
								this.toggleAccordion(item, this.listItems[i].nested[j].collapsed);
							}
							// Third dimension
							if (this.listItems[i].nested[j].nested.length > 0) {
								for (var k = 0; k < this.listItems[i].nested[j].nested.length; k++) {
									if (this.listItems[i].nested[j].nested[k].key == item.key) {
										this.listItems[i].nested[j].nested[k].collapsed = (!this.listItems[i].nested[j].nested[k].collapsed) ?
											true : false;
										this.toggleAccordion(item, this.listItems[i].nested[j].nested[k].collapsed);
									}
								}
							}
						}
					}
				}
			},
			toggleAccordion(item, value) {
				var collapsed = document.getElementsByClassName('nestable-item-' + item.key);
				if (collapsed.length > 0) {
					for (var i = 0; i < collapsed.length; i++) {
						if (value)
							collapsed[i].querySelector('ol').classList.add('hidden')
						else
							collapsed[i].querySelector('ol').classList.remove('hidden')
					}
				}
			},
			switchGroup(id) {
				this.selectedDivision = id;

				Promise.all([
					api.get('/groups/?page_size=100'),
					api.get('/categories/tree/' + this.selectedDivision + '/', {}),
				])
					.then(([groupsList, tree]) => {
						let list = [];
						let categories = [];
						let inactives = [];
						let groups = [];

						groupsList.data.results.forEach(g => {
							groups.push(g);
						});

						//list
						if (tree.data.tree.list.length > 0) {
							tree.data.tree.list.forEach(r => {

								let childRows = [];
								// First dimension
								r.nested.forEach(child => {
									let secondChildList = [];

									// Second dimension
									if (child.nested.length > 0) {
										child.nested.forEach(secondChild => {
											// Third last dimension
											let thirdChildList = [];
											secondChild.nested.forEach(thirdChild => {
												let tempThirdChild = {
													key: thirdChild.key,
													class: 'purple-text-color',
													text: thirdChild.text,
													productClass: thirdChild.class,
													type: 'category',
													collapsed: false,
													nested: thirdChild.nested,
													visible: true,
													card: 'tree',
												};
												thirdChildList.push(tempThirdChild);
											});

											let secondTempChild = {
												key: secondChild.key,
												class: 'purple-text-color',
												text: secondChild.text,
												productClass: secondChild.class,
												type: 'category',
												collapsed: false,
												nested: thirdChildList,
												visible: true,
												card: 'tree',
											};
											secondChildList.push(secondTempChild);
										});
									}

									let childRow = {
										key: child.key,
										class: 'purple-text-color',
										text: child.text,
										productClass: child.class,
										type: 'category',
										collapsed: false,
										nested: secondChildList,
										visible: true,
										card: 'tree',
									};
									childRows.push(childRow);
								});
								let rowData = {
									key: r.key,
									class: 'purple-text-color',
									text: r.text,
									productClass: r.class,
									type: 'category',
									collapsed: false,
									nested: childRows,
									visible: true,
									card: 'tree',
								};
								list.push(rowData);
							})
						}
						//categories,classes,inactives
						tree.data.tree.categories.forEach(r => {
							let rowData = {
								key: r.key,
								class: 'purple-text-color',
								text: r.text,
								type: 'category',
								collapsed: false,
								visible: true,
								card: 'category',
							};
							categories.push(rowData);
						})
						tree.data.tree.inactives.forEach(r => {
							let rowData = {
								key: r.key,
								class: 'purple-text-color',
								text: r.text,
								type: 'inactive',
								collapsed: false,
								visible: true,
								card: 'inactive',
							};
							inactives.push(rowData);
						})

						this.listItems = list;
						this.newCategories = categories;
						this.unactiveCategories = inactives;
						this.groups = groups;
					})
			},
			trashRow(item) {
				switch (item.type) {
					case 'category':
						api.patch('/categories/' + item.key + '/', {
							is_active: false,
							is_deleted: true
						}).then(response => {
							if (response.status == 200) {
								for (let index = 0; index < this.listItems.length; index++) {
									if (item.key == this.listItems[index].key)
										this.listItems.splice(index, 1);
								}
								message.success(this.$i18n.t('productcat.success.deleted'));
							} else {
								message.success(this.$i18n.t('productcat.error.unknown'));
							}
						});

						break;
					default:

						break;
				}

			},
			setActive(item) {
				api.patch('/categories/' + item.key + '/', {
					is_active: true,
					is_deleted: false,
					parent: null
				}).then(response => {
					if (response.status == 200) {

						// Remove from old list
						switch (item.card) {
							case 'category':
								for (let index = 0; index < this.newCategories.length; index++) {
									if (item.key == this.newCategories[index].key)
										this.newCategories.splice(index, 1);
								}
								break;
							case 'tree':
								for (let index = 0; index < this.listItems.length; index++) {
									if (item.key == this.listItems[index].key)
										this.listItems.splice(index, 1);
								}
								break;
							case 'inactive':
								for (let index = 0; index < this.unactiveCategories.length; index++) {
									if (item.key == this.unactiveCategories[index].key)
										this.unactiveCategories.splice(index, 1);
								}
								break;
							default:
								break;
						}
						item.card = 'category';
						item.type = 'category';
						this.newCategories.push(item);

						message.success(this.$i18n.t('productcat.success.set_active'));
					} else {
						message.error(this.$i18n.t('productcat.error.unknown'));
					}

				});
			},
			setInactive(item) {
				api.patch('/categories/' + item.key + '/', {
					is_active: false,
					is_deleted: false
				}).then(response => {
					if (response.status == 200) {
						// Remove from old list
						switch (item.card) {
							case 'category':
								for (let index = 0; index < this.newCategories.length; index++) {
									if (item.key == this.newCategories[index].key)
										this.newCategories.splice(index, 1);
								}
								break;
							case 'tree':
								for (let index = 0; index < this.listItems.length; index++) {
									if (item.key == this.listItems[index].key)
										this.listItems.splice(index, 1);
								}
								break;
							case 'inactive':
								for (let index = 0; index < this.unactiveCategories.length; index++) {
									if (item.key == this.unactiveCategories[index].key)
										this.unactiveCategories.splice(index, 1);
								}
								break;
							default:
								break;
						}
						item.card = 'inactive';
						this.unactiveCategories.push(item);

						message.success(this.$i18n.t('productcat.success.set_inactive'));
					} else {
						message.error(this.$i18n.t('productcat.error.unknown'));
					}
				});
			},
			filterBySearchBar() {
				for (let index = 0; index < this.listItems.length; index++) {
					const element = this.listItems[index];
					if (element.text.includes(this.searchBarInput) || element.code == this.searchBarInput) {
						this.listItems[index].visible = true;
					} else {
						this.listItems[index].visible = false;
					}
				}
			},
			setItemState(item, state) {
				if (state == 'active') {
					item.type = 'category';
				}
			},
			editItem(item) {
				this.$router.push({path: '/admin/product/categories/' + item.key + '/edit'}, {cat_id: item.key});
				if (item.type == 'category') {

				} else {
					this.$router.push({name: 'admin_product_cat_add'});
				}
			},
			moveToTree(item) {
				switch (item.card) {
					case 'category':

						api.patch('/categories/' + item.key + '/', {
							parent: 0
						}).then(response => {
							if (response.status == 200) {
								for (let index = 0; index < this.newCategories.length; index++) {
									if (item.key == this.newCategories[index].key)
										this.newCategories.splice(index, 1);
								}

								message.success(this.$i18n.t('productcat.success.category_tree'));
								item.card = 'tree';
								item.nested = [];
								item.productClass = [];
								this.listItems.push(item);
							} else {
								message.error(this.$i18n.t('productcat.error.unknown'));
							}
						});
						break;

					default:
						break;
				}
			},
			revertNestCategory(item) {
				for (let index = 0; index < this.listItems.length; index++) {
					if (item.key == this.listItems[index].key)
						this.listItems.splice(index, 1);
				}

				switch (item.type) {
					case 'category':
						api.patch('/categories/' + item.key + '/', {
							parent: null
						}).then(response => {
							if (response.status == 200) {
								message.success(this.$i18n.t('productcat.success.category_back'));
								item.card = 'category';
								this.newCategories.push(item);
							} else {
								message.error(this.$i18n.t('productcat.error.unknown'));
							}
						});

						break;

					case 'inactive':
						item.card = 'inactive';
						this.unactiveCategories.push(item);
						break;

					default:
						break;
				}

			},
			beforeMove({dragItem, pathFrom, pathTo}) {
			},
			onTreeChange(items, pathTo) {
				let parentId = 0;
				let newOrder = 0;
				let parentOrder = 0;
				// Find parent to update child to
				for (let i = 0; i < pathTo.items.length; i++) {
					let parent = pathTo.items[i];

					if (items.key == parent.key) {
						parentOrder = i;
					}

					if (parent.nested.length > 0) {
						for (let j = 0; j < parent.nested.length; j++) {

							let parentChild = parent.nested[j];

							parentChild.order = j;
							if (items.key == parentChild.key) {
								newOrder = j;
							}

							// First dimension
							if (parentChild.key == items.key) {
								parentId = parent.key;
							} else {
								// Second dimension
								if (parentChild.nested.length > 0) {
									for (let k = 0; k < parentChild.nested.length; k++) {
										if (parentChild.nested[k] != null) {
											if (
												parentChild.nested[k].key == items.key
												&& parentChild.nested[k].key > 0) {
												parentId = parentChild.key;
											} else {
												// Third dimension
												if (parentChild.nested[k].nested.length > 0) {
													for (let l = 0; l < parentChild.nested[k].nested.length; l++) {
														if (
															parentChild.nested[k].nested[l].key == items.key &&
															parentChild.nested[k].nested[l].key > 0)
														{
															parentId = parentChild.nested[k].key;
														} else {
															// Fourth dimension
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}


				if (parentId > 0) {
					// Update parent
					api.patch('/categories/' + items.key + '/', {
						parent: parentId,
						order: newOrder
					});
				} else {
					// Reset parent
					api.patch('/categories/' + items.key + '/', {
						parent: 0,
						order: parentOrder,
					});
				}
			},
			onTreeInput(value) {
			},
			moveItem({dragItem, pathFrom, pathTo}) {
			},
			select_group(g) {
				this.errors = {}
				this.tender.warehouse = null
				api.get('/warehouses/', {
					params: {
						is_active: true,
						page_size: 100,
						group: g.id
					}
				})
					.then(r => {
						this.warehouses = r.data.results
					})
			},
			close_modal() {
				this.showModal = false
			},
			open_modal(data1, data2) {
				this.showModal = true
				this.modal_data_1 = data1
				this.modal_data_2 = data2
			},
			make_search() {
				this.$router.push({
					query: {
						search: this.search,
						ordering: this.ordering,
						page: 1,
						start: this.tender.start,
						finish: this.tender.finish,
						warehouse: this.tender.warehouse,
						group: this.tender.group,
						additional: this.tender.additional_info,
						tender_id: this.tender.id
					}
				})
			},
		},
		beforeRouteEnter(to, from, next) {
			getData(to.params.id, to, data => {
				next(vm => {
					Object.assign(vm.$data, data)
				})
			})
		},
		beforeRouteUpdate(to, from, next) {
			getData(to.params.id, to, data => {
				Object.assign(this.$data, data)
				next()
			})
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/ProductCategories.vue